import { HelmetDexteel, useUserContext } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { CatalogOperator } from "../../models/CatalogOperator";
import { getOperators } from "../../repositories/CatalogOperatorRepository";
import { TableOperator } from "./components/TableOperator";

export const operatorUrl = "/configuration/operators/";

export const useOperators = (onError?: (error: Error) => void) => {
	const {
		state: { defaultAreaId },
	} = useUserContext();
	return useQuery<CatalogOperator[], Error>({
		queryKey: ["operators", defaultAreaId],
		queryFn: ({ signal }) => getOperators({ defaultAreaId }, signal),
		onError: onError,
	});
};

export const CatalogOperatorPage = () => {
	const { operatorId } = useParams();

	return (
		<>
			<HelmetDexteel title="Operators" />
			<TableOperator operatorId={operatorId} />
		</>
	);
};
